export default __webpack_public_path__ + "static/media/v45_62.dbe8bdbe.png";